import { render, staticRenderFns } from "./WorkingBoard.vue?vue&type=template&id=4b08eeda"
import script from "./WorkingBoard.vue?vue&type=script&lang=js"
export * from "./WorkingBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports